import { ClientInferRequest, ClientInferResponseBody } from "@ts-rest/core";

import { contract } from "#app/http/api";
import { api } from "#app/http/api";
import { ApiError } from "#shared/infra/apiError";

export type UpdateMaterialsVolumetricPrice = ClientInferResponseBody<
  typeof contract.materials.updateMaterialsVolumetricPrice
>;

export type UpdateMaterialsVolumetricPriceDto = ClientInferRequest<
  typeof contract.materials.updateMaterialsVolumetricPrice
>["body"] & { id: string };

export const updateMaterialsVolumetricPrice = async ({
  id,
  ...body
}: UpdateMaterialsVolumetricPriceDto): Promise<UpdateMaterialsVolumetricPrice> => {
  const response = await api.materials.updateMaterialsVolumetricPrice.mutation({
    params: { id },
    body,
  });

  if (response.status === 200) {
    return response.body;
  }

  throw new ApiError("Failed to update MaterialsVolumetricPrice", response.status, response.body);
};
